import { render, staticRenderFns } from "./societes-forfaitaires.html?vue&type=template&id=36e16a14&scoped=true&external"
import script from "./societes-forfaitaires.js?vue&type=script&lang=js&external"
export * from "./societes-forfaitaires.js?vue&type=script&lang=js&external"
import style0 from "./societes-forfaitaires.scss?vue&type=style&index=0&id=36e16a14&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e16a14",
  null
  
)

export default component.exports